import { APP_INITIALIZER, Injector, PLATFORM_ID, Provider } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from 'ngx-carnival-tourbo-components';
import { takeUntil } from 'rxjs';

/**
 * Hace que Enter confirme cualquier modal de confirmación (`ModalComponent`)
 * abierto con `MatDialog`, sin repetir la lógica en cada punto de apertura.
 */
export const provideModalEnterConfirm = (): Provider => ({
  provide: APP_INITIALIZER,
  multi: true,
  useFactory: (injector: Injector, platformId: object) => () => {
    if (!isPlatformBrowser(platformId)) return;
    injector
      .get(MatDialog)
      .afterOpened.subscribe((ref) => bindEnterToConfirm(ref));
  },
  deps: [Injector, PLATFORM_ID],
});

const bindEnterToConfirm = (ref: MatDialogRef<any>): void => {
  const modal = ref.componentInstance;
  if (!(modal instanceof ModalComponent)) return;

  ref
    .keydownEvents()
    .pipe(takeUntil(ref.afterClosed()))
    .subscribe((event: KeyboardEvent) => {
      if (event.key !== 'Enter' || event.repeat) return;
      // Cancela la activación nativa del botón que tenga el foco dentro del
      // overlay (por defecto MatDialog enfoca "Cancelar"), así Enter siempre
      // confirma y nunca dispara dos acciones.
      event.preventDefault();
      modal.handleClick();
    });
};
